import styled from 'styled-components'
import { StyledButtonBase } from 'components/Button/Button.styles'

export const StyledSubscriptionsBlock = {
  Wrapper: styled.div`
    margin: 0 auto 28px;
    border-radius: 24px;
    background-size: cover;
  `,
  Title: styled.h2`
    margin-bottom: 16px;
    font-weight: 700;
    font-size: 24px;
    line-height: 30px;
    text-align: center;
  `,
  ButtonContainer: styled.div`
    margin: 16px 0;
  `,
  Button: styled.button`
    ${StyledButtonBase};
    margin: 24px auto;
    max-width: 328px;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
  `,
  Disclaimer: styled.p`
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    color: #848993;

    a {
      color: #0091ff;
      text-decoration: underline;
    }
  `,
}
